import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import { ru } from "vuetify/lib/locale"

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    current: 'ru',
    locales: { ru }
  },
  theme: {
    themes: {
      light: {
        primary: "#4971d0"
      }
    }
  }
});
